var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconSportFootball24X24 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_sport_football24x24",
    transform: "translate(1560 145)",
    fill: "#999"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45862",
    d: "M-1549.463-136.2c-.445.623-1.6,2.226-2.137,2.849.178.534.623,1.87.89,2.4a22.692,22.692,0,0,0,3.472.178c.445-.534,1.425-1.781,1.692-2.137a30.763,30.763,0,0,0-1.247-3.027Z",
    transform: "translate(-.95 -.965)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45863",
    d: "M-1551.247-139.466a11.75,11.75,0,0,0-3.472-.534l-1.781,2.315a34.238,34.238,0,0,0,1.246,3.205,23.986,23.986,0,0,0,2.849.445c.445-.534,1.6-2.048,2.137-2.849A22.183,22.183,0,0,0-1551.247-139.466Z",
    transform: "translate(-.396 -.548)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45864",
    d: "M-1544.634-140.014h0a8,8,0,0,0-7.372-4.986,5.849,5.849,0,0,0-1.243.089h-.089a8.028,8.028,0,0,0-6.661,7.924v.445h0a7.8,7.8,0,0,0,.977,3.383h0a8.028,8.028,0,0,0,10.836,3.205,7.894,7.894,0,0,0,3.553-10.061Zm-3.464,9.615-.266-.979c-1.155,0-2.309-.089-3.464-.178a4.232,4.232,0,0,1-1.954,1.068,6.138,6.138,0,0,0,.178,1.157c-.089,0-.266-.089-.355-.089a4.47,4.47,0,0,1-.178-1.068,6.541,6.541,0,0,1-2.4-1.692h0a6.9,6.9,0,0,1-1.865-.356,2.235,2.235,0,0,1-.355-.623.767.767,0,0,0,.533.267l.622.178c.355.089.622.089.977.178a9.164,9.164,0,0,1,.622-2.226c-.444-.89-1.243-3.027-1.332-3.294l-1.421-.445a7.846,7.846,0,0,0-.977,2.137h0v-.979a10.878,10.878,0,0,1,.8-1.514h0a3.35,3.35,0,0,1,2.842-3.65h0a17.768,17.768,0,0,1,1.954-1.692,2.623,2.623,0,0,1,.888-.178,9.97,9.97,0,0,0-1.332.979,4.351,4.351,0,0,0-1.155,1.068,8.569,8.569,0,0,0,.622,1.6,11.7,11.7,0,0,1,3.464.534,6.891,6.891,0,0,1,2.132-1.425,9.7,9.7,0,0,0-.888-2.226c-.444-.089-1.776-.445-2.576-.534a3.635,3.635,0,0,1,.977-.089,8.235,8.235,0,0,1,2.576.445l-.622.089a10.4,10.4,0,0,1,.888,2.315,9.559,9.559,0,0,1,2.132,1.6h1.954c.089.089.089.267.177.356h-1.954a6.4,6.4,0,0,1-.533,2.582,32.494,32.494,0,0,1,1.244,3.116,5.448,5.448,0,0,0,1.243-.089A7.878,7.878,0,0,1-1548.1-130.4Z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconSportFootball24X24);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_sport_football24x24.af0f99a7ae5096fc37cb0aa63be6ceb6.svg";